import { createAction, props } from '@ngrx/store'
import { RateCardMetaStructure, RateCardMetaStructureField } from '../models'
import { ApplicationSettingConfig, ApplicationSettingsItem } from '../models/application-settings-item.model'

import { ApplicationSetting } from '@app/core/model/company.model'

export enum ApplicationSettingsActionTypes {
  GET_RATE_CARD_META_STRUCTURE = '[Application Settings] Get Rate Card Meta Structure',
  GET_RATE_CARD_META_STRUCTURE_FAIL = '[Application Settings] Get Rate Card Meta Structure Fail',
  GET_RATE_CARD_META_STRUCTURE_SUCCESS = '[Application Settings] Get Rate Card Meta Structure Success',

  SAVE_RATE_CARD_META_STRUCTURE = '[Application Settings] Save Rate Card Meta Structure',
  SAVE_RATE_CARD_META_STRUCTURE_FAIL = '[Application Settings] Save Rate Card Meta Structure Fail',
  SAVE_RATE_CARD_META_STRUCTURE_SUCCESS = '[Application Settings] Save Rate Card Meta Structure Success',

  GET_APPLICATION_SETTINGS = '[Application Settings] Get application settings',
  GET_APPLICATION_SETTINGS_FAIL = '[Application Settings] Get application settings Fail',
  GET_APPLICATION_SETTINGS_SUCCESS = '[Application Settings] Get application settings Success',
  SET_APPLICATION_SETTINGS = '[Application Settings] Set application settings',

  UPDATE_APPLICATION_SETTING = '[Application Settings] Update application setting',
  UPDATE_APPLICATION_SETTING_FAIL = '[Application Settings] Update application setting Fail',
  UPDATE_APPLICATION_SETTING_SUCCESS = '[Application Settings] Update application setting Success',

  CLEAR_TRAFFIC_IMPORT_CACHE = '[Application Settings] Clear traffic import cache',
  CLEAR_TRAFFIC_IMPORT_CACHE_FAIL = '[Application Settings] Clear traffic import cache Fail',
  CLEAR_TRAFFIC_IMPORT_CACHE_SUCCESS = '[Application Settings] Clear traffic import cache Success',
}

const getRateCardMetaStructure = createAction(ApplicationSettingsActionTypes.GET_RATE_CARD_META_STRUCTURE)
const getRateCardMetaStructureSuccess = createAction(
  ApplicationSettingsActionTypes.GET_RATE_CARD_META_STRUCTURE_SUCCESS,
  props<{ rateCardMetaStructure: RateCardMetaStructure }>()
)
const getRateCardMetaStructureFail = createAction(
  ApplicationSettingsActionTypes.GET_RATE_CARD_META_STRUCTURE_FAIL,
  props<{ error: Error }>()
)

const saveRateCardMetaStructure = createAction(
  ApplicationSettingsActionTypes.SAVE_RATE_CARD_META_STRUCTURE,
  props<{ fields: RateCardMetaStructureField[] }>()
)
const saveRateCardMetaStructureSuccess = createAction(
  ApplicationSettingsActionTypes.SAVE_RATE_CARD_META_STRUCTURE_SUCCESS,
  props<{ rateCardMetaStructure: RateCardMetaStructure }>()
)
const saveRateCardMetaStructureFail = createAction(
  ApplicationSettingsActionTypes.SAVE_RATE_CARD_META_STRUCTURE_FAIL,
  props<{ error: Error }>()
)

const getApplicationSettings = createAction(ApplicationSettingsActionTypes.GET_APPLICATION_SETTINGS)
const getApplicationSettingsSuccess = createAction(
  ApplicationSettingsActionTypes.GET_APPLICATION_SETTINGS_SUCCESS,
  props<{ settings: ApplicationSettingsItem[] }>()
)
const getApplicationSettingsFail = createAction(
  ApplicationSettingsActionTypes.GET_APPLICATION_SETTINGS_FAIL,
  props<{ error: Error }>()
)
const setApplicationSettings = createAction(
  ApplicationSettingsActionTypes.SET_APPLICATION_SETTINGS,
  props<{ settings: ApplicationSettingsItem[] }>()
)

const updateApplicationSetting = createAction(
  ApplicationSettingsActionTypes.UPDATE_APPLICATION_SETTING,
  props<{ setting: ApplicationSettingConfig }>()
)
const updateApplicationSettingSuccess = createAction(
  ApplicationSettingsActionTypes.UPDATE_APPLICATION_SETTING_SUCCESS,
  props<{ setting: ApplicationSettingConfig; response: ApplicationSetting[] }>()
)
const updateApplicationSettingFail = createAction(
  ApplicationSettingsActionTypes.UPDATE_APPLICATION_SETTING_FAIL,
  props<{ error: Error; setting: ApplicationSettingConfig }>()
)

const clearTrafficImportCache = createAction(ApplicationSettingsActionTypes.CLEAR_TRAFFIC_IMPORT_CACHE)
const clearTrafficImportCacheSuccess = createAction(ApplicationSettingsActionTypes.CLEAR_TRAFFIC_IMPORT_CACHE_SUCCESS)
const clearTrafficImportCacheFail = createAction(
  ApplicationSettingsActionTypes.CLEAR_TRAFFIC_IMPORT_CACHE_FAIL,
  props<{ error: Error }>()
)

export const ApplicationSettingsActions = {
  getRateCardMetaStructure,
  getRateCardMetaStructureSuccess,
  getRateCardMetaStructureFail,
  saveRateCardMetaStructure,
  saveRateCardMetaStructureSuccess,
  saveRateCardMetaStructureFail,
  getApplicationSettings,
  getApplicationSettingsSuccess,
  getApplicationSettingsFail,
  setApplicationSettings,
  updateApplicationSetting,
  updateApplicationSettingSuccess,
  updateApplicationSettingFail,
  clearTrafficImportCache,
  clearTrafficImportCacheSuccess,
  clearTrafficImportCacheFail,
}
